import { createSlice } from '@reduxjs/toolkit'
// import { attendacePolicy } from '../../reduxModels';

const initialState: any = {
    refresh: false,
}

const leaveSlice = createSlice({
    name: 'leave',
    initialState,
    reducers: {
        setLeave: (state, action) => {
            return { ...state, ...action.payload };
        }
    },
});

export const { setLeave } = leaveSlice.actions;

export default leaveSlice.reducer